/**
 * Coverax Header – Scroll, Trust-Leiste, Handy-Suche
 */
(function () {
  'use strict';

  const header = document.getElementById('header');
  if (!header) return;

  const TRUST_KEY = 'coverax-trust-bar-hidden';
  const SEARCH_KEY = 'coverax-header-search-hidden';

  function syncHeaderHeight() {
    const height = Math.round(header.getBoundingClientRect().height);
    if (!height) return;
    document.documentElement.style.setProperty('--header-height', height + 'px');
    document.body.style.setProperty('--header-height', height + 'px');
  }

  function scheduleHeaderHeightSync() {
    requestAnimationFrame(function () {
      syncHeaderHeight();
      requestAnimationFrame(syncHeaderHeight);
    });
  }

  function updateHeaderScroll() {
    if (isMobileHeader()) {
      header.classList.remove('header--scrolled');
      return;
    }
    if (document.body.classList.contains('gmenu-body-lock')) return;
    header.classList.toggle('header--scrolled', window.scrollY > 20);
  }

  function isMobileHeader() {
    return window.matchMedia('(max-width: 768px)').matches;
  }

  function syncSearchFocusButtons() {
    header.querySelectorAll('[data-header-search-focus]').forEach(function (button) {
      button.hidden = !isMobileHeader();
    });
  }

  function focusSearchInput() {
    if (!searchInput) return;
    searchInput.focus();
  }

  function setSearchHidden(hidden) {
    header.classList.toggle('is-search-hidden', hidden);
    if (hidden) {
      document.documentElement.style.setProperty('--header-search-height', '0px');
      document.body.style.setProperty('--header-search-height', '0px');
    } else {
      document.documentElement.style.removeProperty('--header-search-height');
      document.body.style.removeProperty('--header-search-height');
    }
    try {
      sessionStorage.setItem(SEARCH_KEY, hidden ? '1' : '0');
    } catch (err) {}
    syncSearchFocusButtons();
    scheduleHeaderHeightSync();
  }

  const trust = header.querySelector('[data-header-trust]');
  if (trust) {
    try {
      if (sessionStorage.getItem(TRUST_KEY) === '1') {
        header.classList.add('is-trust-hidden');
      }
    } catch (e) {}

    const closeBtn = trust.querySelector('[data-header-trust-close]');
    if (closeBtn) {
      closeBtn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        header.classList.add('is-trust-hidden');
        try {
          sessionStorage.setItem(TRUST_KEY, '1');
        } catch (err) {}
        scheduleHeaderHeightSync();
      });
    }

    const details = trust.querySelector('details');
    if (details) {
      details.addEventListener('toggle', syncHeaderHeight);
    }
  }

  const searchInput = document.getElementById('coverax-mobile-search');
  const mobileCloseBtn = header.querySelector('[data-coverax-mobile-search-close]');

  function syncMobileCloseButton() {
    if (!mobileCloseBtn || !searchInput) return;
    const hasQuery = searchInput.value.trim().length > 0;
    const resetLabel = mobileCloseBtn.getAttribute('data-label-reset');
    const closeLabel = mobileCloseBtn.getAttribute('data-label-close');
    mobileCloseBtn.classList.toggle('is-clear', hasQuery);
    if (hasQuery && resetLabel) {
      mobileCloseBtn.setAttribute('aria-label', resetLabel);
    } else if (closeLabel) {
      mobileCloseBtn.setAttribute('aria-label', closeLabel);
    }
  }

  if (searchInput) {
    if (mobileCloseBtn) {
      searchInput.addEventListener('input', syncMobileCloseButton);
      syncMobileCloseButton();
    }

    searchInput.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' || event.isComposing || !searchInput.value.trim()) return;

      event.preventDefault();
      const predictiveSearch = searchInput.closest('predictive-search');
      const selectedResult = predictiveSearch && predictiveSearch.querySelector('[aria-selected="true"]');
      if (selectedResult) selectedResult.setAttribute('aria-selected', 'false');
      searchInput.removeAttribute('aria-activedescendant');
      searchInput.form.requestSubmit();
    });
  }

  header.querySelectorAll('[data-header-search-focus]').forEach(function (button) {
    button.addEventListener('click', function () {
      setSearchHidden(false);
      focusSearchInput();
    });
  });

  header.querySelectorAll('[data-header-search-close]').forEach(function (button) {
    button.addEventListener('click', function () {
      if (searchInput && searchInput.value) {
        searchInput.value = '';
        searchInput.dispatchEvent(new Event('input', { bubbles: true }));
        searchInput.focus();
        return;
      }
      setSearchHidden(true);
    });
  });

  const desktopSearchEl = header.querySelector('.header-desktop-search__predictive');
  const desktopOverlay = header.querySelector('.header-desktop-search__overlay');

  function closeDesktopSearch() {
    if (desktopSearchEl && typeof desktopSearchEl.close === 'function') {
      desktopSearchEl.close(true);
    }
  }

  function syncDesktopSearchOverlay() {
    const isOpen = !!(desktopSearchEl && desktopSearchEl.hasAttribute('open'));
    document.documentElement.classList.toggle('is-desktop-search-open', isOpen);
    document.body.classList.toggle('is-desktop-search-open', isOpen);
  }

  if (desktopOverlay) {
    desktopOverlay.querySelectorAll('[data-desktop-search-close]').forEach(function (control) {
      control.addEventListener('click', function (event) {
        event.preventDefault();
        closeDesktopSearch();
      });
    });
  }

  if (desktopSearchEl && typeof MutationObserver === 'function') {
    new MutationObserver(syncDesktopSearchOverlay).observe(desktopSearchEl, {
      attributes: true,
      attributeFilter: ['open'],
    });
    syncDesktopSearchOverlay();
  }

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    if (!document.documentElement.classList.contains('is-desktop-search-open')) return;
    event.preventDefault();
    closeDesktopSearch();
  });

  try {
    if (sessionStorage.getItem(SEARCH_KEY) === '1') {
      setSearchHidden(true);
    }
  } catch (e) {}

  window.addEventListener('scroll', updateHeaderScroll, { passive: true });
  window.addEventListener('resize', function () {
    syncSearchFocusButtons();
    syncHeaderHeight();
    if (isMobileHeader() && document.documentElement.classList.contains('is-desktop-search-open')) {
      closeDesktopSearch();
    } else {
      syncDesktopSearchOverlay();
    }
  }, { passive: true });
  updateHeaderScroll();
  syncSearchFocusButtons();
  syncHeaderHeight();

  if (typeof ResizeObserver === 'function') {
    new ResizeObserver(syncHeaderHeight).observe(header);
  }
})();
